import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useHandleHistoryBack } from '@pocapan/shared/utils/useHandleHistoryBack';

type ModalType = 'historyBack' | 'tabChange';

export const useTradingPhotoCardModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalType, setModalType] = useState<ModalType | null>(null);
  const [pendingTab, setPendingTab] = useState<number | null>(null);

  const navigate = useNavigate();
  const location = useLocation();
  const handleHistoryBack = useHandleHistoryBack();

  const openModal = (type: ModalType, tabIndex?: number) => {
    setIsOpen(true);
    setModalType(type);
    setPendingTab(tabIndex ?? null);
  };

  const closeModal = () => {
    setIsOpen(false);
    setModalType(null);
    setPendingTab(null);
  };

  const handleConfirm = ({
    onTabChangeClear
  }: {
    onTabChangeClear: (tabIndex: number) => void;
  }) => {
    if (modalType === 'historyBack') {
      handleHistoryBack();
    } else if (modalType === 'tabChange' && pendingTab !== null) {
      onTabChangeClear(pendingTab);
      navigate(`${location.pathname}?tabIndex=${pendingTab}`, { replace: true });
    }
    closeModal();
  };

  return {
    isOpen,
    modalType,
    openModal,
    closeModal,
    handleConfirm
  };
};
